/* eslint-disable max-len */
const zhHk = {
  CancellationRequest: '申請取消',
  Heading: '請提供以下資料。所有欄位均為必填。',
  Note: '需要取消預訂？有疑問嗎？我們可提供說明請針對需要取消的預訂輸入以下欄位。',
  PartnerNote:
    '目前我們會優先處理旅遊日期較早的取消申請。如你未有於旅遊日期前收到取消確認亦請放心，我們會儘快處理有關申請，你無需進行任何操作。',
  SubmitNote:
    '由於行程受阻個案眾多，退款處理程序或稍有延遲。對你造成不便，我們深感抱歉，並衷心感謝你耐心配合。',
  Disclaimer:
    '重要須知：此表格僅適用於旅遊日期為 2021 年 12 月 31 日或之前的預訂。',
  Itin: '行程編號 (載於你的行程或確認電郵上的 11 - 15 位字元)',
  EmailAddress: '預訂時使用的電郵地址',
  PhoneNumber: '預訂時使用的電話號碼',
  Reason: '原因',
  Submit: '繼續',
  Success: '我們已收到你的申請',
  Failed: '很抱歉',
  InProgress: '我們正在搶修',
  TryAgain: '返回',
  PhoneErrorMessage: '請輸入有效的電話號碼',
  EmailErrorMessage: '請輸入有效的電郵地址',
  ItinErrorMessage: '請輸入有效的行程編號',
  ResponseEligibleHeader: '我們已找到了你的行程',
  ResponseEligibleSubmit: '是，取消預訂',
  ResponseEligibleNeverMind: '否，不要取消',
  ResponseOnlyLodgingWithRefund:
    '你有 {x} 筆符合退款資格的住宿預訂。如你選擇取消，我們將透過你原有的付款方式退款給你。',
  ResponseOnlyLodgingWithCoupon:
    '你有 {x} 筆符合禮券資格的住宿預訂。如你選擇取消，我們會發還一張與原預訂價格相等的禮券。',
  ResponseOnlyLodgingInEligible:
    '你有 {x} 筆不符合免費取消資格的住宿預訂。如你選擇取消，預訂將須遵守住宿合作夥伴的標準取消政策規定。',
  ResponseLodgingWithOtherLob:
    '此行程的其他所有預訂均須遵守合作夥伴的政策規定。',
  ResponseNoLodgingWithOtherLob: '此行程的所有預訂均須遵守合作夥伴的政策規定。',
  ResponseAlreadyCancelled:
    '你有 {x} 筆住宿預訂已被取消，由於行程受阻個案眾多，退款處理程序或稍有延遲。如有任何疑問，請致電客戶支援。',
  ResponseNoFlexAvailable:
    '你有 {x} 筆不符合退款或禮券資格的住宿預訂。如現在取消，預訂將須遵守住宿合作夥伴的標準取消政策規定。取消政策時有變更，請於行程開始前 8 日回來查看最新的取消政策。',
  ResponseInvalidDuplicateItinerary:
    '你已提交了申請，目前我們會優先處理旅遊日期較早的取消申請。如你未有於旅遊日期前收到取消確認亦請放心，我們會儘快處理有關申請，你無需進行任何操作。',
  ResponseElligibleConfirmation: '需要取消預訂？',
  ResponseInvalidUnknown:
    '找不到此行程/確認編號，請檢查號碼然後再試一次。編號可於原有預訂收到的電郵中找到。',
  ResponseInvalidItineraryNotFound:
    '找不到此行程/確認編號，請檢查號碼然後再試一次。編號可於原有預訂收到的電郵中找到。',
  ResponseInvalidTripMoreThanSevenDays: '無法處理你的申請。',
  ResponseInvalidTripIsLcc:
    '航空公司會處理所有取消預訂，請直接與航空公司聯絡。如需更多資料，請登入你的帳戶並查閱你的行程。目前正在處理的取消申請可能需要最多 72 小時才會於行程中顯示為已取消。',
  ResponseInvalidTripIsTicketless:
    '航空公司會處理所有取消預訂，請直接與航空公司聯絡。如需更多資料，請登入你的帳戶並查閱你的行程。目前正在處理的取消申請可能需要最多 72 小時才會於行程中顯示為已取消。',
  ResponseInvalidItinerary: '無法識別此行程編號，請再試一次。',
  ResponseInvalidStatus: '出現錯誤。請再試一次。',
  ResponseInvalidEmail:
    '無法識別此電郵地址，或電郵與此行程紀錄不符，請確保電郵與預訂時所用的相同。',
  ResponseInvalidPhone: '無法識別此電話號碼，請確保號碼與預訂時所用的相同。',
  ResponseTripHasLccFlight:
    '我們已取消了你的部分預訂，有關無法取消的預訂請直接與供應商查詢。你可於網上行程查閱需要取消的預訂。目前正在處理的取消申請可能需要最多 72 小時才會於行程中顯示為已取消。',
  ResponseErrorTripWithin24Hrs:
    '我們無法處理於出發前 24 小時內的取消預訂。如需更多資料，請登入你的帳戶並查閱你的行程。',
  ResponseInvalidTripInCruise:
    '我們無法透過此表格接受遊輪取消申請。請登入帳戶，然後於行程中取消預訂。',
};

export default zhHk;
